import routers from '../secrets-web/src/config/routers';
import {
} from '@ant-design/icons';

export default {
  ...routers,
  AUTH_ROUTERS: [
    {
      name: 'SPLASH',
      path: '/',
      element: 'Splash',
    },
    {
      name: 'AUTHENTICATE',
      path: '/authenticate',
      element: 'Authenticate',
      not_auth: true
    },
    {
      name: 'LOGIN',
      path: '/login',
      element: 'Login',
      not_auth: true
    },
    {
      name: 'REGISTER',
      path: '/register',
      element: 'Register',
      not_auth: true
    },
    {
      name: 'LOCK',
      path: '/lock',
      element: 'Lock',
    },
    {
      name: 'CREATE_MASTER_PASSWORD',
      path: '/create-master-password',
      element: 'CreateMasterPassword',
    },
    {
      name: 'SETUP_2FA',
      path: '/setup-2fa',
      element: 'Setup2FA',
    },
  ],
  ADMIN_ROUTERS: [
    ...routers.ADMIN_ROUTERS.filter((m) => !['WORKSPACE_INTEGRATION', 'WORKSPACE_EMAIL_SETTING'].includes(m.name)),
    {
      name: 'CREATE_WORKSPACE',
      path: '/workspaces/create',
      element: 'CreateWorkspace',
      hideLayout: true,
      label: "create_workspace.title",
    },
    {
      name: 'ACCOUNT_DETAILS',
      path: '/account-details',
      element: 'AccountDetails',
      label: "account_details.title",
    },
    {
      name: 'ACCOUNT_SECURITY',
      path: '/account-security',
      element: 'Security',
      label: "security.title",
    }
  ]
};
